import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "../../../../components/form/Button";
import { breadcrumbs } from "../../../../actions/appActions";
import { push } from "react-router-redux";
import {
  OfficialsActive,
  OfficialsActiveOvm,
  OfficialsLegitimate,
} from "../../components/grids/OfficialGrid";
import CroFileUpload from "../../components/generalForm/CroFileUpload";
import {
  isOvm,
  isInternal,
  isLegitimate,
  isOfficialAdmin,
} from "../../CroUtils";
import { noop } from "lodash";
import loginInfo from "../../components/LoginInfo";
import H, { enumOnCondition } from "../../helpEnum";
import { deleteOfficials, getFunctionaryNoticeTypes, markOfficialsAsInspected } from "../../CroActions";
import ShowOverviewHistoryButton from "../../components/audit/ShowOverviewHistoryButton";

const fileBtnStyle = { margin: "0 0 0 10px", textDecoration: "none" };

class OfficialsAll extends Component {
  state = {
    loading: false,
    items: [], //dummy.. import api action doesnt return anything, this is to force reload grid from api
    functionaryNoticeTypes: [],
  };

  async componentWillMount() {
    const { auth, dispatch } = this.props;
    if (isInternal(auth)) {
      this.setState({ loading: true });
      const functionaryNoticeTypes = await getFunctionaryNoticeTypes(dispatch);
      this.setState({ functionaryNoticeTypes: functionaryNoticeTypes.items, loading: false });
    }
    this.props.breadcrumbs([{ label: "Funkcionáři" }]);
  }

  onAdd = (url) => () => this.props.push(`${url}/funkcionari/form`);
  onRowClick =
    (url) =>
    ({ id }) =>
      this.props.push(`${url}/funkcionari/form/${id}`);

  onImportFinished = (results) => {
    this.setState({ items: [...this.state.items, 0] });
    window.sessionStorage.setItem('import_officials', JSON.stringify(results));
    this.props.getLoginInfo()();
  };

  onRemove = () => {
    const { auth } = this.props;
    if (isOvm(auth) || isOfficialAdmin(auth)) {
      return this.onRemoveOfficials(auth);
    }
    return noop;
  };

  onCheckboxFn = () => {
    return noop;
  };

  onRemoveOfficials = (auth) => async (ids) => {
    await deleteOfficials(ids, auth)(this.props.dispatch);
    this.setState({ items: [...this.state.items, 0] });
  };

  onCreateAppeal = (noticeTypeId, selected) => {  
    const { auth } = this.props;
    if(selected.length === 0) return;

    this.props.push((selected.length === 1) ?
      { pathname: `${auth.startUrl}/funkcionari/${selected[0]}/vyzva`, state: { noticeTypeId } } :
      { pathname: `${auth.startUrl}/funkcionari/hromadna-vyzva`,
        state: {
          officialsIds: selected,
          noticeTypeId: noticeTypeId
      }
    });
  }

  onOfficialsMarkInspected = async (selected) => {
    const { auth, dispatch } = this.props;
    await markOfficialsAsInspected(auth.startUrl, selected)(dispatch);
    this.setState({ items: [...this.state.items, 0] });
  }

  render() {
    const { auth, dispatch } = this.props;
    const canAdd = isOvm(auth); // || isOfficialAdmin(auth);
    const canAddCsv = isOvm(auth);
    const o = enumOnCondition(isOvm(auth));
    const canDelete = isOfficialAdmin(auth);

    if (isLegitimate(auth)) {
      this.props.breadcrumbs([{ label: "Veřejní funkcionáři" }]);
    }

    const ImportCSVButton = (
      <CroFileUpload
        key="icsv"
        label="Import z CSV/EXCEL souboru"
        onFileUploaded={this.onImportFinished}
        url="/podpurny-organ/api/funkcionari/import"
        helpEnum={o(H.OVM_BTN_IMPORT.r)}
        tooltipPosition="bottom-right"
        accept=".csv, .xlsx, .xls"
        dispatch={dispatch}
        loadingText="Probíhá import veřejných funkcionářů. Prosím čekejte..."
      />
    );

    const CSVTemplateButton = (
      <a
        key="scsv"
        href={`${process.env.PUBLIC_URL}/files/vzor-importu.xlsx`}
        style={fileBtnStyle}
      >
        <Button
          type="button"
          label="EXCEL šablona pro import"
          helpEnum={o(H.OVM_BTN_TEMPLATE.r)}
          tooltipPosition="bottom-right"
        />
      </a>
    );

    const GridComponent = isInternal(auth)
      ? OfficialsActive
      : isLegitimate(auth)
        ? OfficialsLegitimate
        : OfficialsActiveOvm;
    return (this.state.loading ? (<></>) :
      <div>
        <ShowOverviewHistoryButton auth={auth} segment="funkcionari" />
        <GridComponent
          gridName="officialsGrid_all"
          url={`${auth.startUrl}/api/funkcionari`}
          items={this.state.items}
          adding={canAdd}
          helpEnumAdd={o(H.OVM_BTN_ADD.r)}
          toolbarButtons={[]}//{canAddCsv ? [ImportCSVButton, CSVTemplateButton] : []}
          onAdd={canAdd ? this.onAdd(auth.startUrl) : noop}
          deleting={canDelete}
          onRemove={this.onRemove()}
          onRowClick={this.onRowClick(auth.startUrl)}
          moreCheckboxFns={isInternal(auth)}
          moreCheckboxFnsItems={this.state.functionaryNoticeTypes.map((type) => ({ label: type.name, value: type.id, onClick: (selected) => { this.onCreateAppeal(type.id, selected) } })) }
          fnText={"Zaslat výzvu"}
          onCheckboxFn={this.onCheckboxFn()}
          allowCheck={isInternal(auth)}
          otherCheckboxFns={isInternal(auth) ? [{ label: "Zkontrolováno", onClick: this.onOfficialsMarkInspected }] : []}
        />
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(
  loginInfo(OfficialsAll),
);
